// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"f985a076","240":"39c4179e","474":"044f5590","565":"2ed6dc56","643":"34df012a","838":"0132395d"}[chunkId] + ".chunk.js";
};